import '../styles/core.scss'; // Blueprint & Core styles
import * as bootstrap from 'bootstrap-5'; // Bootstrap 5 javascript support

// Expose Bootstrap globally for legacy Sprockets/CoffeeScript files
// that cannot use ES6 imports (e.g., app/assets/javascripts/**/*.coffee)
// This allows CoffeeScript files to use: new bootstrap.Modal(element)
window.bootstrap = bootstrap;
bootstrap.Tooltip.Default.allowList.button = ['data-clipboard-target'];
